/**
 * @author varun
 */
/**
 * <div jv-video-recorder movie-name="{{question.vid}}" duration="{{question.timeToAnswer}}" video-control="{{{'recording':'start','done':'stop'}[videoStatus]}}" options='{width:"760px",height:"428px",rtmpServer:"fms01.corp.jobvite.com",debugEnabled:true,flashSrc:"/__assets__/scripts/common/video/videorecording.swf"};' >
   </div>

   @attr: "movie-name": unique name with which it will be saved.
   @attr: "duration": how long is the recording.
   @attr: "options": json string options you can pass as the setting. Please look at "jv.videoRecorder.js" file on the options available and option details.
   @attr: "video-control": string that only supports 'start' and 'stop' for now.
 */
angular.module("jv.Common.Directives.VideoRecorder", ['jv.log4javascript'])
	.directive("jvVideoRecorder", ['$timeout', '$log',
		function($timeout, $log) {
			return {
				"restrict": "A",
				"replace": true,
				"template": '<div id="webcam" ng-class="{\'true\':\'magenta\', \'false\':\'noRecord\'}[status==\'recording\']"  ></div>',
				"scope": {
					//options straight away passed from the attribute and get 'eval' within the directive scope.
					options: "@options",
					// controls the flash player, start, stop etc.
					videoControl: "@videoControl",
					movieName: "@movieName",
					duration: "@duration",
					status: "@videoStatus",
				},
				"link": function(scope, element, attribute) {
					scope.$watch('$parent.interviewType', function(newValue) {
						if (angular.isDefined(newValue) && newValue !== "") {
							var practice;
							if (newValue === "recordInterview") {
								practice = false;
							} else if (newValue === "practiceInterview") {
								practice = true;
							}
							var options = scope.$eval(scope.options);
							options.practice = practice;
							$(element).JVideo(options);
						}
					});
					scope.$watch('videoControl', function(newValue) {
						switch (newValue) {
							case 'start':
								$(element).data('JVideo').startRecord({
									"movieName": scope.movieName,
									"duration": scope.duration
								});
								break;
							case 'stop':
								$(element).data('JVideo').stopRecord();
								break;
						}
					});

					scope.emitEvent = function(event, data) {
						if (event === 'DONE_UPLOADING' || event === 'RECORD_ERROR') {
							$timeout(function() {
								scope.$apply(function() {
									scope.$emit(event, data);
								});
							});
						} else {
							//Adding 2 seconds timeout for better user experience when the status of flash/camera/mic etc changes
							$timeout(function() {
								scope.$apply(function() {
									scope.$emit(event, data);
								});
							}, 200);
						}
					};

					$(element).bind("sendLog", function(evt, data) {
						//After the initialization user can switch back and forth between allow and deny. Catch those conditions.
						if(data == "Camera.Muted"){
							scope.emitEvent('CAMERA_NOT_PRESENT', data);
							scope.emitEvent('MIC_NOT_PRESENT', data);
						}
						if(data == "Camera.Unmuted"){
							scope.emitEvent('CAMERA_PRESENT', data);
							scope.emitEvent('MIC_PRESENT', data);
						}
						$log.info(data);
					});

					$(element).bind("recordingStopped", function(evt, data) {
						scope.emitEvent('DONE_UPLOADING', data);
					});

					$(element).bind("recordError", function(evt, data) {
					    if(angular.isDefined(scope)) {
					        $log.info("VideoRecorderDT: Record Error for video: " + scope.movieName);
					    }
						$log.error("Recording Error");
						scope.emitEvent('RECORD_ERROR', data);
					});

					$(element).bind("cameraInitialized", function(evt, data) {
						scope.emitEvent('CAMERA_INITIALIZED', data);
					});

       				$(element).bind("cameraNotPresent", function(evt, data) {
						$log.error("Camera not present");
						scope.emitEvent('CAMERA_NOT_PRESENT', data);
					});

					$(element).bind("cameraPresent", function(evt, data) {
						scope.emitEvent('CAMERA_PRESENT', data);
					});

					$(element).bind("cameraMuted", function(evt, data) {
						scope.emitEvent('CAMERA_MUTED', data);
					});

					$(element).bind("micNotPresent", function(evt, data) {
						$log.error("Mic Not Present");
						scope.emitEvent('MIC_NOT_PRESENT', data);
					});

					$(element).bind("micPresent", function(evt, data) {
						scope.emitEvent('MIC_PRESENT', data);
					});

					$(element).bind("flashInstalled", function(evt, data) {
						scope.emitEvent('FLASH_INSTALLED', data);
					});

					$(element).bind("flashNotInstalled", function(evt, data) {
						$log.error("Flash Not Installed");
						scope.emitEvent('FLASH_NOT_INSTALLED', data);
					});

					$(element).bind("connectionRejected", function(evt, data) {
						$log.error("Connection Rejected");
						scope.emitEvent('CONNECTION_REJECTED', data);
					});
				}
			};
		}
	]);
